import React, { useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

import useHistory from 'hooks/useHistory';
import { pushGtmEvent } from 'services/gtm/gtmEvents';
import { getUri } from 'services/generic';
import { ProductBreadcrumbType } from 'types/ProductPageV2/Products';

import styles from './ProductBackLink.module.scss';

type Props = {
  breadcrumb: ProductBreadcrumbType[];
  classes?: {
    container?: string;
  };
};

/**
 * Product page of website. Contains back link product.
 */
export default function ProductBackLink({
  breadcrumb,
  classes,
}: Props): JSX.Element {
  const { t } = useTranslation(['productPage']);
  const navigate = useNavigate();
  const { previousPath, previousPage, changeColorCounter } = useHistory();

  const url = useMemo(() => {
    if (changeColorCounter > 0 && previousPage) {
      return previousPage;
    } else if (previousPath) {
      return previousPath;
    }

    return getUri(breadcrumb[breadcrumb.length - 1]?.Url || '/');
  }, [previousPath, changeColorCounter, breadcrumb]);

  function handleBackClick(e: React.MouseEvent<HTMLAnchorElement>) {
    e.preventDefault();

    pushGtmEvent({
      event: '_click_other',
      category: 'clic autre - fiche produit',
      element: 'retour vers la page précédente',
    });

    if (changeColorCounter > 0 && previousPage) {
      window.history.go(parseInt(`-${changeColorCounter + 1}`));
    } else if (previousPage) {
      window.history.back();
    } else {
      navigate(url);
    }
  }

  return (
    <div className={classNames(styles.linksContainer, classes?.container)}>
      <Link to={url} className={styles.back} onClick={handleBackClick}>
        <ArrowBackIosIcon className={styles.icon} />
        <span className={styles.desktop}>
          {t('LABEL_BACK_TO_PRODUCT_LIST')}
        </span>
        <span className={styles.mobile}>
          {t('LABEL_BACK_TO_PRODUCT_LIST_MOBILE')}
        </span>
      </Link>
    </div>
  );
}
